(function () {
  function activate(root, index, moveFocus) {
    var tabs = root._paperTabs;
    var panels = root._paperPanels;
    var figures = root._paperFigures;

    tabs.forEach(function (tab, i) {
      var selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      if (selected && moveFocus) tab.focus();
    });

    panels.forEach(function (panel, i) {
      var selected = i === index;
      panel.classList.toggle('is-active', selected);
      panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
      if (selected) panel.removeAttribute('inert');
    });

    var previous = -1;
    figures.forEach(function (figure, i) {
      if (figure.classList.contains('is-active')) previous = i;
    });

    figures.forEach(function (figure, i) {
      var selected = i === index;
      figure.classList.toggle('is-active', selected);
      figure.classList.remove('is-leaving');
      figure.setAttribute('aria-hidden', selected ? 'false' : 'true');
    });

    if (previous >= 0 && previous !== index) {
      figures[previous].classList.add('is-leaving');
      window.clearTimeout(root._paperFade);
      root._paperFade = window.setTimeout(function () {
        figures[previous].classList.remove('is-leaving');
      }, 280);
    }

    window.clearTimeout(root._paperInert);
    root._paperInert = window.setTimeout(function () {
      panels.forEach(function (panel, i) {
        if (i === index) panel.removeAttribute('inert');
        else panel.setAttribute('inert', '');
      });
    }, 280);
  }

  function init(root) {
    if (!root || root.dataset.paperReady === 'true') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-paper-panel]'));
    var figures = Array.prototype.slice.call(root.querySelectorAll('[data-paper-figure]'));
    if (!panels.length) return;

    root._paperTabs = tabs;
    root._paperPanels = panels;
    root._paperFigures = figures;
    root.dataset.paperReady = 'true';

    if (tabs.length < 2) return;

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(root, index, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        activate(root, next, true);
      });
    });

    root.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest('[data-paper-panel]');
      if (!panel || !root.contains(panel)) return;
      var index = panels.indexOf(panel);
      if (index >= 0) activate(root, index, false);
    });

    activate(root, 0, false);
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-paper-details]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  if (document.readyState !== 'loading') boot(document);
})();
